import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AuthActions } from 'store/actions';
import { AuthSelectors } from 'store/selectors';
import AuthModal from 'components/auth/AuthModal';
import { safeSessionStorage } from 'utils/safeStorage';
import { getLoginDestination, isMedianApp } from 'utils/jlifeAuth';
import useJlifeSignIn from './auth/useJlifeSignIn';
import useModal from './useModal';

const stateSelector = createStructuredSelector({
  isAuthenticated: AuthSelectors.isAuthenticated,
  isHardUser: AuthSelectors.isHardUser,
  isAdmin: AuthSelectors.isAdmin,
  isMarketAdmin: AuthSelectors.isMarketAdmin,
  isSuperAdmin: AuthSelectors.isSuperAdmin,
  currentUser: AuthSelectors.currentUser,
});

const useAuthProps = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { signIn } = useJlifeSignIn();
  const [showAuthModal] = useModal(AuthModal);
  const { isAuthenticated, isHardUser, isAdmin, isMarketAdmin, isSuperAdmin, currentUser } = useSelector(stateSelector);

  const onLogin = useCallback(() => {
    // Median keeps the old login modal; everywhere else "Login" goes straight to the JLife sign-in page.
    if (isMedianApp()) {
      showAuthModal();
    } else {
      signIn(getLoginDestination(router?.asPath, router?.query?.redirect_to));
    }
  }, [showAuthModal, signIn, router]);

  const onLogout = useCallback(() => {
    safeSessionStorage.removeItem('marketInitiated');
    dispatch(AuthActions.logout());
    safeSessionStorage.setItem('shownNudgeToLoginPopover', String(true));
  }, [dispatch]);

  return {
    isAuthenticated,
    isHardUser,
    isAdmin,
    isMarketAdmin,
    isSuperAdmin,
    currentUser,
    onLogin,
    onLogout,
  };
};

export default useAuthProps;
